import type { EnumUnion } from '@dresscode-frontend/utility-types';

export const TextVariant = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  CardHeader: 'CardHeader',
  p: 'p',
  pBold: 'pBold',
  pSmall: 'pSmall',
  list: 'list',
  blockquote: 'blockquote',
  tableHead: 'tableHead',
  tableItem: 'tableItem',
  tableItemNumber: 'tableItemNumber',
  inlineCode: 'inlineCode',
  buttonLabel: 'buttonLabel',
  buttonLabelSmall: 'buttonLabelSmall',
  badgeLabel: 'badgeLabel',
  labelLarge: 'labelLarge',
  labelSemiLarge: 'labelSemiLarge',
  label: 'label',
  labelReg: 'labelReg',
  labelSmall: 'labelSmall',
  labelSmallReg: 'labelSmallReg',
  labelExSmall: 'labelExSmall',
  inputLabelLarge: 'inputLabelLarge',
  inputLabel: 'inputLabel',
  numberSemiLarge: 'numberSemiLarge',
  numberLarge: 'numberLarge',
  secret: 'secret',
} as const;
export type TextVariant = EnumUnion<typeof TextVariant>;
